import { LoadingSpinner } from '@web_opxp/components';
import { LanguageProvider, SentryService, isLocalhost, isProduction } from '@web_opxp/features';
import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import Root from './Root';
import { AppActions } from './app';
import { AssetsBaseUrl } from './assets';
import ENV, { BuildID } from './base/env';
import history from './base/historyService';
import './index.scss';
import getStore from './store';

if (!isLocalhost) {
  SentryService.initSentry(isProduction(), BuildID);
}

const store = getStore();
store.dispatch(AppActions.appStart());
const container = document.getElementById('root');
if (!container) {
  throw new Error('Incorrect template. Application root not found on the page!');
}
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <LanguageProvider
      localesPath={ENV.LocalesBaseUrl}
      ns={['common.common', 'common.exercises', 'common', 'training']}
      defaultNS={'training'}
      fallbackNS={'training'}>
      <Router history={history}>
        <Suspense fallback={<LoadingSpinner assetsUrl={AssetsBaseUrl} />}>
          <Root />
        </Suspense>
      </Router>
    </LanguageProvider>
  </Provider>
);
